import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setWebMcpNavigate } from './tools';

/** Hands the router's navigate to the WebMCP tools (registered in main.tsx before React renders). */
export function WebMcpBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    setWebMcpNavigate((path) => navigate(path));
    return () => setWebMcpNavigate(null);
  }, [navigate]);

  return null;
}
